import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { useMutation } from 'react-query'

//constants
import { ERROR_TEXT, LOCAL_STORAGE, REACT_NATIVE_STATUS } from 'constants/index'
//contexts
import AuthContext from 'context/AuthContext'
import LoaderContext from 'context/LoaderContext'
//hooks
import useLocalStorage from './useLocalStorage'
//services
import { orderGiftCardByCampaign } from 'services/ordersService'
//types
import { OrderGiftCardByCampaignRequestBody } from 'types'
//utils
import { handleError, sendRNMessage } from 'utils/utils'

const useOrderGiftCardByCampaignMutation = () => {
  const { user, updateUserData } = useContext(AuthContext)
  const { showLoader, hideLoader } = useContext(LoaderContext)
  const navigate = useNavigate()
  const { setItem, removeItem } = useLocalStorage()

  const { mutate: orderGiftCardByCampaignMutate } = useMutation(
    ({ campaignId, denomination }: OrderGiftCardByCampaignRequestBody) =>
      orderGiftCardByCampaign({ campaignId, denomination }),
    {
      onMutate: () => {
        showLoader()
      },
      onSuccess: (res) => {
        setItem(
          LOCAL_STORAGE.BALANCE_BEFORE_GIFT_CARD_REDEMPTION,
          JSON.stringify({ coins: user?.points, piggyBanks: user?.piggyBanks })
        )
        updateUserData(res.data.updatedUser)
        removeItem(LOCAL_STORAGE.TREMENDOUS_CAMPAIGN_ID)
        removeItem(LOCAL_STORAGE.GIFT_CARD_DENOMINATION)

        if (window.ReactNativeWebView) {
          sendRNMessage({
            status: REACT_NATIVE_STATUS.OPEN_URL,
            url: res.data.link,
          })
        } else {
          window.open(res.data.link, '_blank')
        }
        navigate('/rewards')
      },
      onError: (err) => {
        handleError(err, ERROR_TEXT.choose_gift_card)
        navigate('/rewards')
      },
      onSettled: () => {
        hideLoader()
      },
    }
  )

  return { orderGiftCardMutate: orderGiftCardByCampaignMutate }
}

export default useOrderGiftCardByCampaignMutation
